"use strict";import{a as r,b as a}from"../__chunks__/chunk-HEFO2I3D.js";import{b as e}from"../__chunks__/chunk-CAYY44FX.js";import{i as o}from"../__chunks__/chunk-L6ORX32P.js";o();export{r as useCheckVersion,a as useGetVersion,e as useLocalStorage};
//# sourceMappingURL=index.js.map
